<template>
    <span class="capas-poblacion" :class="{'tooltip-abierto':esteTemaActivo}">
        <DaiCapaGeojson
          id="poblacion_localidades"
          :url="publicPath+'data/capasv2/02_localidades_poligonos.geojson'"
          titulo="Localidades"
          :estilo-capa="{ stroke: { width: 1 ,color:'white'},fill:{color:'transparent'} }"
          :reglas-estilo-capa="{
              clasificacion:'linear',
              columna:'pobtot',
              clases:4,
              colores:['#FFA4FF','#E581FF','#BD5DFF','#9538FF']
          }"
          tipoGeometria="Polygon"
          :z-index="6"
          :renderizarComoImagen="true"
          :visible="localidadesVisible"
          @hover_feature="hoverLocalidades"
          :use-loader="true"

        />
        <DaiCapaGeojson
          id="poblacion_localidades_puntos"
          :url="publicPath+'data/capasv2/loc_puntos_2.geojson'"
          titulo="< 52"
          :estilo-capa="{ circle:{ stroke: { width: 1 ,color:'#F80093'},fill:{color:'#F80093'}, radius:2 } }"
          
          tipoGeometria="Point"
          :z-index="6"
          :renderizarComoImagen="true"
          :visible="localidadesVisible"
          @hover_feature="hoverLocalidades"
          :use-loader="true"
        />

        <DaiCapaGeojson
          id="poblacion_municipios"
          :url="publicPath+'data/capasv2/04_densidad_poblacion.geojson'"
          titulo="Municipios"
          :estilo-capa="{ stroke: { width: 1 ,color:'white'},fill:{color:'transparent'} }"
          :reglas-estilo-capa="{
              clasificacion:'cuantiles',
              columna:'pob_reg',
              clases:4,
              colores:['#EDE6DE','#D2C1AC','#928678','#696156']
          }"
          tipoGeometria="Polygon"
          :z-index="6"
          :renderizarComoImagen="true"
          :visible="municipiosVisible"
          @hover_feature="hoverMunicipios"
          :use-loader="true"
        />
        <div class="tooltip-externo-poblacion" v-if="esteTemaActivo" :style="{'--colorActualTooltip':tooltip_color}">
            <div class="texto">
              <h3>{{tooltip_titulo}}</h3>
                <p v-html="tooltip_p1">
                </p>
                <p v-html=tooltip_p2>
                </p>  
            </div>
            <div class="porcentaje">
                <div>Población indígena {{porcentaje_barra}}%</div>
                <div class="barra" >
                    <div class="relleno" :style="{width:porcentaje_barra+'%'}"></div>
                </div>
               
            </div>
        </div>
    </span>
</template>

<script>
import {mapState} from "vuex"


export default {
    data(){
        return {
            tooltip_titulo:'Region Nororiental',
            tooltip_color: '#847819',
            tooltip_p1:'<b>1,514 localidades</b><br>1,174 rurales | 340 urbanas',
            tooltip_p2:'Poblacion <b>13,329,023 habitantes</b><br>Poblacion indigena <b>553,922 habitantes</b>',
            
            porcentaje_barra: 3.98,
            publicPath: process.env.BASE_URL,
        }
    },
    computed:{
        ...mapState('mapa',['temasExpandidos','poblacionNivelSeleccionado']),
        esteTemaActivo(){
            /*
            var elementReset = document.querySelector('html body div#app.normal-nav div.container.main.view div.main-layout-diagnostico div.card-map-container.distribucion-mapa-diagnostico div.dai-map-container div.dai-map.default-controls div.ol-viewport div.ol-overlaycontainer-stopevent div.dai-reset.ol-unselectable.ol-control');
            if (this.temasExpandidos.poblacion === true){
                elementReset.classList.add('reset-bottom');
            } else {
                if(elementReset != null){
                    elementReset.classList.remove('reset-bottom');
                }                
            }
            */
            return this.temasExpandidos.poblacion
        },
        localidadesVisible(){
            return this.esteTemaActivo && this.poblacionNivelSeleccionado==='localidad'
        },
        municipiosVisible(){
            return this.esteTemaActivo && this.poblacionNivelSeleccionado==='municipio'
        }
    },
    methods:{
        hoverLocalidades(event){
            
            this.tooltip_titulo = event.feature.nom_loc
            this.tooltip_p1= `Municipio <b>${event.feature.nom_mun}</b><br><b>${event.feature.nom_edo}</b>`
            this.tooltip_p2= `Población: <b>${event.feature.pobtot.toLocaleString()} habitantes</b><br> Población indígena: <b>${event.feature.pob_ind.toLocaleString()} habitantes</b>`
            this.tooltip_color = event.feature.geometry.getType().includes('Point') ? event.style.getImage().getFill().getColor() : event.style.getFill().getColor()
            this.porcentaje_barra = event.feature.porcent_ind
        },
        hoverMunicipios(event){
            this.tooltip_titulo = event.feature.nom_mun
            this.tooltip_p1= ` <b>${event.feature.nom_edo}</b>`
            this.tooltip_p2= `Población: <b>${event.feature.pob_reg.toLocaleString()} habitantes</b><br> Población indígena: <b>${event.feature.pobind_reg.toLocaleString()} habitantes</b>`
            this.tooltip_color = event.style.getFill().getColor()
            this.porcentaje_barra = event.feature.porcent_indreg
        }
    },
    watch:{
        esteTemaActivo (nuevoValor){
            let elementReset = document.querySelector('div.dai-map-container  div.dai-reset.ol-unselectable.ol-control');
            let elementoCalles = document.querySelector("div.dai-map-container>button.boton-calles") 
            if (nuevoValor){
                elementReset.classList.add('reset-bottom');
                elementoCalles.classList.add('reset-bottom');
            }else{
                elementReset.classList.remove('reset-bottom');
                elementoCalles.classList.remove('reset-bottom');
            }
        }
    }

}
</script>

<style lang="scss" >
.reset-bottom {
    bottom: 184px !important;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
        bottom: 125px !important;
    }
}
.tooltip-externo-poblacion{
    position: absolute;
    bottom: 0;
    left: 0;
    min-height: 50px;
    width: 100%;
    background-color: white;
    border-top: 1px solid black;
    display: flex;

    .texto{
        padding: 0 1em;
        flex-basis: 50%;
        h3{
            margin-block-start: .5em;
            margin-block-end: 1px;
            font-size: 15px;
            color: var(--colorActualTooltip)
        }

        p{
            font-size: 12px;
            &:first-of-type{
                margin-block-start: 0;
            }
        }
        
    }
    .porcentaje{
        flex-basis: 50%;
        padding-top: 2em;
        .barra{
            
            height: 20px;
            width: 80%;
            border-radius: 5px;
            border: 1px solid var(--colorActualTooltip);
            display: flex;
            justify-content: flex-end;
            .relleno{
                background-color: var(--colorActualTooltip);
                height: 100%;
            }
        }
    }
}
</style>